<app-alert />
<app-global-spinner />
<router-outlet />
